import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { supportedConditions, supportedValues } from './query-util';

export default class EditQueryCondition extends Component {
  static propTypes = {
    constants: PropTypes.array.isRequired,
    fields: PropTypes.array.isRequired,
    fieldOptions: PropTypes.array.isRequired,
    setFieldTouched: PropTypes.func,
    condition: PropTypes.object,
    removeQuery: PropTypes.func,
    saveQuery: PropTypes.func,
  };

  state = {
    selectedField: this.props.condition.query.field,
    selectedFieldError: '',
    selectedCondition: this.props.condition.query.key,
    selectedConditionError: '',
    selectedValue: this.props.condition.query.value,
    selectedValueError: '',
    conjuctionType: this.props.condition.conjunctionType,
    conjuctionTypeError: '',
  };

  removeQuery = () => {
    const { condition } = this.props;
    this.props.removeQuery(condition.id);
  };

  saveQuery = () => {
    const { condition } = this.props;
    const { selectedField, selectedCondition, selectedValue, conjuctionType } = this.state;

    if (condition.id > 1 && !conjuctionType) {
      this.setState({ conjuctionTypeError: 'Please choose Conjuction' });
      return;
    }
    if (!selectedField) {
      this.setState({ selectedFieldError: 'Please select Field' });
      return;
    }
    if (!selectedCondition) {
      this.setState({ selectedConditionError: 'Please select Condition' });
      return;
    }
    if (!selectedValue && !['IS_NOT_NULL', 'IS_NULL'].includes(selectedCondition)) {
      this.setState({ selectedValueError: 'Please select value to be used' });
      return;
    }

    const queryBuilder = {
      conjunctionType: `${condition.id > 1 ? (conjuctionType === 'OR' ? 'OR' : 'AND') : ''}`,
      requiredExternal: selectedValue === 'EXTERNAL',
      query: { field: selectedField, key: selectedCondition, value: selectedValue },
    };
    this.props.saveQuery(condition.id, queryBuilder);
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
      selectedFieldError: '',
      selectedConditionError: '',
      selectedValueError: '',
      conjuctionTypeError: '',
    });
  };

  showSupportedCondition = () => {
    const {
      selectedField,
      selectedCondition,
      selectedValueError,
      selectedConditionError,
    } = this.state;

    if (!selectedField) {
      return '';
    }

    const conditions = supportedConditions(this.props.fields, selectedField);
    const availableValues = supportedValues(
      this.props.constants,
      this.props.fields,
      selectedField,
      selectedCondition,
    );
    return (
      <Fragment>
        <div className="col-3">
          <select
            value={this.state.selectedCondition}
            name="selectedCondition"
            onChange={this.handleChange}
            className="form-control form-control-sm"
          >
            <option value="">Select Condition</option>
            {conditions.map(condition => (
              <option value={condition} key={condition}>
                {condition}
              </option>
            ))}
          </select>
          {selectedConditionError && <p className="text-error">{selectedConditionError}</p>}
        </div>
        <div className="col-3">
          {availableValues.length > 0 && (
            <select
              value={this.state.selectedValue}
              name="selectedValue"
              onChange={this.handleChange}
              className="form-control form-control-sm"
            >
              <option value="">Select Value</option>
              {availableValues.map(val => (
                <option value={val.name} key={val.name}>
                  {val.name}
                </option>
              ))}
            </select>
          )}
          {selectedValueError && <p className="text-error">{selectedValueError}</p>}
        </div>
      </Fragment>
    );
  };

  showSaveButton = () => {
    const { condition } = this.props;
    const { selectedField, selectedCondition, selectedValue, conjuctionType } = this.state;
    let showButton = false;

    if (condition.query.key !== selectedCondition) {
      showButton = true;
    }

    if (condition.query.field !== selectedField) {
      showButton = true;
    }

    if (
      condition.conjunctionType &&
      conjuctionType &&
      condition.conjunctionType !== conjuctionType
    ) {
      showButton = true;
    }

    if (condition.requiredExternal) {
      if (selectedValue !== 'EXTERNAL') {
        showButton = true;
      }
    } else if (condition.query.value !== selectedValue) {
      showButton = true;
    }

    if (showButton) {
      return (
        <button onClick={this.saveQuery} type="button" className="btn btn-sm btn-theme-submit">
          <i className="wb webconnect-save-regular"></i>
        </button>
      );
    }
  };

  render() {
    const { fieldOptions, condition } = this.props;
    const { conjuctionTypeError, selectedFieldError, selectedField, conjuctionType } = this.state;

    if (fieldOptions) {
      return (
        <Fragment>
          <div className="col-2">
            {condition.id > 1 && (
              <select
                value={conjuctionType}
                name="conjuctionType"
                onChange={this.handleChange}
                className="form-control form-control-sm"
              >
                <option value="">Conjunction</option>
                <option value="AND">AND</option>
                <option value="OR">OR</option>
              </select>
            )}
            {conjuctionTypeError && <p className="text-error">{conjuctionTypeError}</p>}
          </div>

          <div className="col-2">
            <select
              name="selectedField"
              value={selectedField}
              onChange={this.handleChange}
              className="form-control form-control-sm"
            >
              <option value="">Select Field</option>
              {fieldOptions.map(field => (
                <option value={field.value} key={field.value}>
                  {field.label}
                </option>
              ))}
            </select>
            {selectedFieldError && <p className="text-error">{selectedFieldError}</p>}
          </div>
          {this.showSupportedCondition()}
          <div className="col-2">
            {this.showSaveButton()}
            &nbsp;
            <button
              onClick={this.removeQuery}
              type="button"
              className="btn btn-sm btn-theme-delete"
            >
              <i className="wb webconnect-trash-regular"></i>
            </button>
          </div>
        </Fragment>
      );
    } else {
      return '';
    }
  }
}
